import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { UpdateCoupon } from 'commons/models/coupon';
import { AppContext, UserContext } from 'commons-ui';

import useService from '../../utils/useService';
import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);
	const history = useHistory();
	const location = useLocation();
	const { requestUpdateCoupon } = useService();

	const updateCoupon = (updatedData: UpdateCoupon) => {
		setShowLoader(true);

		requestUpdateCoupon(app.appName, { ...updatedData, updatedBy: _get(user, 'userName', '') }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while updating the partner coupon', { type: 'error' });
					setShowLoader(false);
					return;
				}

				showAlert('Record updated');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		updateCoupon(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: hydrateFormData(_get(location, ['state', 'rowData'])),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
